import { listingsApiV1 } from '@app/services'
import { getUserCurrency } from '@app/utils'

import { DEFAULT_LISTINGS_SORTING, ListingsSorting } from '@lib/components'

import { FetchListingsResponse } from './types'
import { QueryMode } from '../types'

export const fetchPublishedListings = async (
  lang: string,
  mode: QueryMode = 'Puzzle',
  count = 30,
  skip = 0,
  input?: string,
  transactionType?: string,
  sort: ListingsSorting = DEFAULT_LISTINGS_SORTING
): Promise<FetchListingsResponse> => {
  try {
    const baseLang = lang.split('-')[0]

    const { data } = await listingsApiV1.get<FetchListingsResponse>(
      'listings',
      {
        params: {
          'query.mode': mode,
          'query.count': count,
          'query.skip': skip,
          'query.sort': sort || DEFAULT_LISTINGS_SORTING,
          'query.filters.state': 'Published',
          'query.filters.input': input || undefined,
          'query.filters.transactionType': transactionType || undefined,
          'query.currencyId': getUserCurrency(),
        },
        headers: {
          'Accept-Language': baseLang,
        },
      }
    )

    return data
  } catch (error) {
    console.error('Failed to fetch published listings', error)
    return { listings: [], total: 0 }
  }
}
